import { useRecipeFavourites } from "@/hooks/recipe-favourites";
import { usePopularRecipes } from "@/hooks/recipe-views";
import { useAuth } from "@/hooks/useAuth";
import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { RecipeSection } from "./recipe-showcase";
import { fromFavourite, fromPopular } from "./recipe-adapters";

export function ManagerRecipeOverviewWidget() {
  const { i18n } = useLingui();
  const { hasPermission } = useAuth();
  const canReadRecipes = hasPermission("recipe:read");
  const { data: favouritesData, isLoading: isFavouritesLoading } = useRecipeFavourites({ limit: 6 }, canReadRecipes);
  const { data: popularData, isLoading: isPopularLoading } = usePopularRecipes({ limit: 6 }, canReadRecipes);

  const favourites = favouritesData?.data?.map(fromFavourite) ?? [];
  const popular = popularData?.data?.map(fromPopular) ?? [];

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-2 px-3">
        <h1 className="text-5xl font-semibold leading-none text-(--color-text-primary)">{i18n._(msg`Manager Dashboard`)}</h1>
        <p className="text-base leading-snug text-(--color-text-secondary)">
          {i18n._(msg`Track high-performing recipes and team favorites across your assigned scope.`)}
        </p>
      </div>

      <RecipeSection
        title={i18n._(msg`Team Favourites`)}
        count={favouritesData?.meta.total ?? 0}
        recipes={favourites}
        isLoading={isFavouritesLoading}
      />

      <RecipeSection
        title={i18n._(msg`Most Popular`)}
        count={popularData?.meta.total ?? 0}
        recipes={popular}
        isLoading={isPopularLoading}
      />
    </div>
  );
}
